<template>
  <div class="p-2">
    <div class="container-fluid">
      <div class="row header mt-4 mb-4">
        <div class="col">
          <h1>UB 04 Claim</h1>
          </div>
        </div>
          <div class="col">
          <div class="row ub-form mb-3">
          <b-input-group prepend="PAT. CNTRL #" class="mr-3">
            <b-form-input></b-form-input>
          </b-input-group>
          <b-input-group prepend="MED REC #" class="mr-3">
            <b-form-input></b-form-input>
          </b-input-group>
              <b-input-group prepend="TYPE OF BILL" class="mr-3">
                <b-form-input></b-form-input>
              </b-input-group>
          </div>
          </div>
          <div class="col">
          <div class="row ub-form mb-3">
            <b-input-group prepend="FED. TAX NO." class="mr-3">
              <b-form-input></b-form-input>
            </b-input-group>
            <b-form-group label="STATEMENT COVERS PERIOD">
              <div class="field-container">
            <b-input-group prepend="START DATE">
              <b-form-input></b-form-input>
            </b-input-group>
              <b-input-group prepend="END DATE" class="mr-3">
                <b-form-input></b-form-input>
              </b-input-group>
              </div>
            </b-form-group>
          </div>
          </div>
      <div class="col">
        <div class="row ub-form mb-4">
          <b-input-group prepend="PATIENT NAME" class="mr-3">
            <b-form-input></b-form-input>
          </b-input-group>
          <b-input-group prepend="PATIENT ADDRESS" class="mr-3">
            <b-form-input></b-form-input>
          </b-input-group>
        </div>
      </div>
      <div class="col">
        <div class="row ub-form mb-3">
      <b-input-group prepend="BIRTHDATE" class="mr-3">
        <b-form-input></b-form-input>
      </b-input-group>
      <b-input-group prepend="SEX" class="mr-3">
        <b-form-input></b-form-input>
      </b-input-group>
        </div>
      </div>
      <div class="col">
        <div class="row ub-form mb-3">
          <b-form-group label="ADMISSION">
            <div class="field-container">
          <b-input-group prepend="DATE">
            <b-form-input></b-form-input>
          </b-input-group>
          <b-input-group prepend="HOUR">
            <b-form-input></b-form-input>
          </b-input-group>
          <b-input-group prepend="TYPE">
            <b-form-input></b-form-input>
          </b-input-group>
          <b-input-group prepend="SRC" class="mr-3">
            <b-form-input></b-form-input>
          </b-input-group>
            </div>
          </b-form-group>
        </div>
      </div>
          <div class="col">
          <div class="row ub-form mb-3">
          <b-input-group prepend="DHR" class="mr-3">
            <b-form-input></b-form-input>
          </b-input-group>
          <b-input-group prepend="STAT" class="mr-3">
            <b-form-input></b-form-input>
          </b-input-group>
          <b-input-group prepend="ACDT STATE" class="mr-3">
            <b-form-input></b-form-input>
          </b-input-group>
          </div>
        </div>
    <div class="col">
      <div class="row ub-form mb-3">
        <b-form-group label="CONDITION CODES">
          <div class="field-container">
            <b-input-group>
              <b-form-input></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-form-input></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-form-input></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-form-input></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-form-input></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-form-input></b-form-input>
            </b-input-group>
            <b-input-group>
            <b-form-input></b-form-input>
          </b-input-group>
            <b-input-group>
              <b-form-input></b-form-input>
            </b-input-group>
            <b-input-group class="mr-3">
              <b-form-input></b-form-input>
            </b-input-group>
          </div>
        </b-form-group>
      </div>
    </div>
      <div class="col">
        <div class="row ub-form mb-3">
          <b-form-group label="OCCURRENCE">
            <div class="field-container">
            <b-input-group prepend="DATE">
              <b-form-input></b-form-input>
            </b-input-group>
            <b-input-group prepend="CODE" class="mr-3">
              <b-form-input></b-form-input>
            </b-input-group>
            </div>
            <div class="field-container">
            <b-input-group prepend="DATE">
              <b-form-input></b-form-input>
            </b-input-group>
            <b-input-group prepend="CODE" class="mr-3">
              <b-form-input></b-form-input>
            </b-input-group>
          </div>
            <div class="field-container">
              <b-input-group prepend="DATE">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="CODE" class="mr-3">
                <b-form-input></b-form-input>
              </b-input-group>
            </div>
            <div class="field-container">
              <b-input-group prepend="DATE">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="CODE" class="mr-3">
                <b-form-input></b-form-input>
              </b-input-group>
            </div>
          </b-form-group>
        <b-form-group label="OCCURRENCE SPAN">
            <div class="field-container">
            <b-input-group prepend="CODE">
              <b-form-input></b-form-input>
            </b-input-group>
            <b-input-group prepend="FROM">
              <b-form-input></b-form-input>
            </b-input-group>
            <b-input-group prepend="THROUGH">
              <b-form-input></b-form-input>
            </b-input-group>
            </div>
            <div class="field-container">
              <b-input-group prepend="CODE">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="FROM">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="THROUGH">
                <b-form-input></b-form-input>
              </b-input-group>
            </div>
            <div class="field-container">
              <b-input-group prepend="CODE">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="FROM">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="THROUGH">
                <b-form-input></b-form-input>
              </b-input-group>
            </div>
            <div class="field-container">
              <b-input-group prepend="CODE">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="FROM">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="THROUGH">
                <b-form-input></b-form-input>
              </b-input-group>
            </div>
          </b-form-group>
        </div>
        </div>
      <div class="col">
        <div class="row ub-form mb-3">
          <b-form-group label="VALUE CODES">
            <div class="field-container">
            <b-input-group prepend="CODE">
              <b-form-input></b-form-input>
            </b-input-group>
            <b-input-group prepend="AMOUNT" class="mr-3">
              <b-form-input></b-form-input>
            </b-input-group>
            </div>
            <div class="field-container">
              <b-input-group prepend="CODE">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="AMOUNT" class="mr-3">
                <b-form-input></b-form-input>
              </b-input-group>
            </div>
            <div class="field-container">
              <b-input-group prepend="CODE">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="AMOUNT" class="mr-3">
                <b-form-input></b-form-input>
              </b-input-group>
            </div>
          </b-form-group>
          <b-form-group label="VALUE CODES">
            <div class="field-container">
              <b-input-group prepend="CODE">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="AMOUNT" class="mr-3">
                <b-form-input></b-form-input>
              </b-input-group>
            </div>
            <div class="field-container">
              <b-input-group prepend="CODE">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="AMOUNT" class="mr-3">
                <b-form-input></b-form-input>
              </b-input-group>
            </div>
            <div class="field-container">
              <b-input-group prepend="CODE">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="AMOUNT" class="mr-3">
                <b-form-input></b-form-input>
              </b-input-group>
            </div>
          </b-form-group>
          <b-form-group label="VALUE CODES">
            <div class="field-container">
              <b-input-group prepend="CODE">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="AMOUNT">
                <b-form-input></b-form-input>
              </b-input-group>
            </div>
            <div class="field-container">
              <b-input-group prepend="CODE">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="AMOUNT">
                <b-form-input></b-form-input>
              </b-input-group>
            </div>
            <div class="field-container">
              <b-input-group prepend="CODE">
                <b-form-input></b-form-input>
              </b-input-group>
              <b-input-group prepend="AMOUNT">
                <b-form-input></b-form-input>
              </b-input-group>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="col">
        <div class="row ub-form mb-3">
          <b-form-group label="REV CD">
              <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
          </b-form-group>
          <b-form-group label="DESCRIPTION">
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
          </b-form-group>
          <b-form-group label="HCPCS/RATE/HIPPS CODE">
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
          </b-form-group>
          <b-form-group label="SERV DATE">
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
          </b-form-group>
          <b-form-group label="SERV UNITS">
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
          </b-form-group>
          <b-form-group label="TOTAL CHARGES">
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
            <b-form-input></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="col">
      <div class="row ub-form mb-3">
        <b-form-group label="PAYER NAME">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
        <b-form-group label="HEALTH PLAN ID">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
        <b-form-group label="REL INFO">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
        <b-form-group label="ASG BEN">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
        <b-form-group label="EST. AMOUNT DUE">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
        <b-form-group label="NPI">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
      </div>
      </div>
      <div class="col">
      <div class="row ub-form mb-3">
        <b-form-group label="INSURED'S NAME">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
        <b-form-group label="PATIENT REL">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
        <b-form-group label="INSURED'S UNIQUE ID">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
        <b-form-group label="GROUP NAME">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
        <b-form-group label="INSURANCE GROUP NO.">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
      </div>
      </div>
      <div class="col">
      <div class="row ub-form mb-3">
        <b-form-group label="TREATMENT AUTHORIZATION CODES">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
        <b-form-group label="DOCUMENT CONTROL NUMBER">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
        <b-form-group label="EMPLOYER NAME">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
        </b-form-group>
        </div>
      </div>
      <div class="col">
      <div class="row ub-form mb-3">
        <b-input-group prepend="ADMIT DX" class="mr-3">
          <b-form-input></b-form-input>
        </b-input-group>
        <b-input-group prepend="PATIENT REASON DX" class="mr-3">
          <b-form-input></b-form-input>
        </b-input-group>
        <b-input-group prepend="PPS CODE" class="mr-3">
          <b-form-input></b-form-input>
        </b-input-group>
        <b-input-group prepend="ECI" class="mr-3">
          <b-form-input></b-form-input>
        </b-input-group>
      </div>
      </div>
      <div class="col">
      <div class="row ub-form mb-3">
        <b-form-group label="PRINCIPAL PROCEDURE">
          <div class="field-container">
          <b-input-group prepend="DATE">
            <b-form-input></b-form-input>
          </b-input-group>
          <b-input-group prepend="CODE" class="mr-3">
            <b-form-input></b-form-input>
          </b-input-group>
          </div>
        </b-form-group>
        <b-form-group label="OTHER PROCEDURE">
          <div class="field-container">
          <b-input-group prepend="DATE">
            <b-form-input></b-form-input>
          </b-input-group>
          <b-input-group prepend="CODE">
            <b-form-input></b-form-input>
          </b-input-group>
          </div>
        </b-form-group>
      </div>
      </div>
      <div class="col">
      <div class="row ub-form mb-3">
        <b-form-group label="ATTENDING">
          <div class="field-container">
          <b-input-group prepend="NPI">
            <b-form-input></b-form-input>
          </b-input-group>
          <b-input-group prepend="LAST">
            <b-form-input></b-form-input>
          </b-input-group>
          <b-input-group prepend="FIRST">
            <b-form-input></b-form-input>
          </b-input-group>
          <b-input-group prepend="QUAL">
            <b-form-input></b-form-input>
          </b-input-group>
          </div>
        </b-form-group>
      </div>
      </div>
      <div class="col">
      <div class="row ub-form mb-3">
        <b-form-group label="REMARKS">
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
          <b-form-input></b-form-input>
            <b-form-input></b-form-input>
        </b-form-group>
      </div>
      </div>
    </div>
    </div>
</template>

<script>

  import ErrorsMixin from '@/mixins/ErrorsMixin'

  export default {
    name: 'UB04Claim',

    mixins: [ErrorsMixin]
  }
</script>

<style scoped>
.ub-form{
  display: flex;
  flex-wrap: nowrap;
  align-items: baseline;
}

.field-container {
  display: flex;
}
</style>
